import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonItemDivider, IonLabel } from '@ionic/angular/standalone';

@Component({
  selector: 'crowdctrl-item-divider',
  standalone: true,
  imports: [CommonModule, IonItemDivider, IonLabel],
  templateUrl: './item-divider.component.html',
  styleUrl: './item-divider.component.css',
})
export class ItemDividerComponent {
  @Input() label = '';
  @Input() dividerClass?: string;
  @Input() labelClass?: string;

  get hostClassString(): string {
    const parts: string[] = ['crowdctrl-item-divider'];
    const extra = this.dividerClass?.trim();
    if (extra) {
      parts.push(extra);
    }
    return parts.join(' ');
  }

  get labelClassString(): string {
    const parts: string[] = ['crowdctrl-item-divider-label'];
    const extra = this.labelClass?.trim();
    if (extra) {
      parts.push(extra);
    }
    return parts.join(' ');
  }
}
